const bisector = 1.2

/*
 *
 *  Draws a triangle around the origin, X at (0,0)
 *
 *    C-----------B
 *     \         /
 *      \   X   /
 *       \     /
 *        \   /
 *          A
 */
export default function (width) {
  return function () {
    var rx = width / 2
      , ry = rx * bisector / 2

    return 'M0,' + ry + // Put pen on A
           'L' + rx + ',' + -ry + // Go to B
           ' ' + -rx + ',' + -ry + // Then to C
           'Z' // Head back to A
  }
}
